document.addEventListener("DOMContentLoaded", function () {
  const variant_dropdowns = document.querySelectorAll(".variant-dropdown");
  let selectedVariant = null;
  let activeInput = null; 
  const cancelButtons = document.querySelectorAll(".cancel-button");
  const updateButtons = document.querySelectorAll(".update-button");
  const editButtons = document.querySelectorAll(".edit-button");

  editButtons.forEach(function (editButton) {
    editButton.addEventListener("click", function (event) {
      event.preventDefault();
    const target = editButton.getAttribute("data-target");
      const container = document.querySelector(target);

      if (container) {
        container.style.display = container.style.display === "block" ? "none" : "block";
      }
      const parent = editButton.parentElement;
      const grandparent = parent ? parent.parentElement : null;

      if (grandparent) {
        const quantityContainer = grandparent.querySelector(".quantity-popover-container");
        
        if (quantityContainer) {
          activeInput = quantityContainer.querySelector("input");

          if (activeInput) {
            const itemIndex = activeInput.getAttribute("data-itemindex"); // Obtener index del item
            console.log("Item Index:", itemIndex);
          }
        }
      }
    });
  });

  variant_dropdowns.forEach(function (dropdown) {
    dropdown.addEventListener("change", function () {
      selectedVariant = dropdown.value;
      if (activeInput) {
        const itemIndex = parseInt(activeInput.getAttribute("data-itemindex"), 10);
        const variantCurrent = parseInt(activeInput.getAttribute("data-quantity-variant-id"), 10);
        updateButtons.forEach(function (updateButton) {
          updateButton.addEventListener("click", function (event) {
            event.preventDefault();
            fetch("/cart.js")
            .then((response) => response.json())
            .then((cart) => {
              const cartItem = cart.items.find((item) => item.variant_id === variantCurrent);
              if (!cartItem) {
                console.error("Not found item.");
                return;
              }
    
              console.log('cartItem', cartItem);
    
              fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  id: cartItem.key,
                  quantity: 0, 
                }),
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Item deleted:", data);
    

                  fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      id: selectedVariant, 
                      quantity: cartItem.quantity, 
                    }),
                  })
                    .then((response) => response.json())
                    .then((newCart) => {
                      console.log("nuew variant add:", newCart);
                    window.location.reload(); 
                    })
                    .catch((error) => console.error("Error:", error));
                })
                .catch((error) => console.error("Error:", error));
            });
          });
        });
     
      }
    });
  });

  cancelButtons.forEach(function (cancelButton) {
    cancelButton.addEventListener("click", function (event) {
      event.preventDefault();
      const container = cancelButton.closest(".container-variants");
      container.style.display = "none";
    });
  });
  
});